// extracted by mini-css-extract-plugin
export var tosLink = "_b1-0";